import React, { useEffect } from 'react';
import { Wrapper, WrapperProps } from '../Wrapper/Wrapper';
import { useAdobeView } from './useAdobeView';

interface PdfViewerProps extends WrapperProps {
  url: string;
  fileName: string;
  id?: string;
  displayOptions?: AdobeDC.PreviewFileOpts;
  onReachEnd?: () => void;
}

export const PdfViewer: React.FC<PdfViewerProps> = ({
  url,
  fileName,
  id = 'adobe-dc-view',
  displayOptions,
  onReachEnd,
  ...rest
}) => {
  const [adobeView] = useAdobeView(id);

  useEffect(() => {
    if (adobeView) {
      if (onReachEnd) {
        adobeView.registerCallback(
          AdobeDC.View.Enum.CallbackType.EVENT_LISTENER,
          ev => {
            switch (ev.type) {
              case AdobeDC.View.Enum.FilePreviewEvents.PREVIEW_PAGE_VIEW_SCROLLED:
                const { clientHeight, scrollHeight, scrollTop } = ev.data;

                if (onReachEnd && scrollHeight - scrollTop - clientHeight < 1) {
                  onReachEnd();
                }

                break;
              case AdobeDC.View.Enum.FilePreviewEvents.PAGES_IN_VIEW_CHANGE:
                // Trigger onReachEnd() when the document only has one page that fits entirely on the viewer
                if (onReachEnd && ev.data.endPage.fractionVisible === 1) {
                  console.log(ev.data);
                  onReachEnd();
                }

                break;
            }
          },
          {
            enableFilePreviewEvents: true,
            listenOn: [
              AdobeDC.View.Enum.FilePreviewEvents.PREVIEW_PAGE_VIEW_SCROLLED,
              AdobeDC.View.Enum.FilePreviewEvents.PAGES_IN_VIEW_CHANGE,
            ],
          },
        );
      }

      adobeView.previewFile(
        { content: { location: { url } }, metaData: { fileName } },
        displayOptions,
      );
    }
  }, [adobeView, fileName, url, onReachEnd]);

  return (
    <Wrapper {...rest} css="height: 100%;">
      <div id={id} />
    </Wrapper>
  );
};
